import React from "react";

export const goalOutline = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <g fill="currentColor" stroke="currentColor" strokeWidth=".5">
        <path d="M12 1.2a10.8 10.8 0 1 0 0 21.6 10.8 10.8 0 0 0 0-21.6Zm0 20.4a9.6 9.6 0 1 1 0-19.2 9.6 9.6 0 0 1 0 19.2Z" />
        <path d="M12 4.8a7.2 7.2 0 1 0 0 14.4 7.2 7.2 0 0 0 0-14.4ZM12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12Z" />
        <path d="M12 8.4a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2Zm0 6a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8Z" />
      </g>
    </svg>
  );
};
